import request from '../../api/request';

export const getCertificateFormStructure = (certificateTypeCode: string) => {
  return request(
    `students-portal/student-certificates/certificate-type/${certificateTypeCode}/form`,
  );
};
